module.exports = ".example-spacer {\n  flex: 1 1 auto;\n}\n\n"